
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface stateProps {
    open:   boolean;
}

const initialState : stateProps = {
    open: true,
};

export const loadingSlice = createSlice({
    name: 'loading',
    initialState: initialState,
    reducers: {
        setReducerLoading: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.open = payload.open;
        },
    },
})

export const { setReducerLoading } = loadingSlice.actions

export default loadingSlice.reducer